import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthFrame } from "@/layout/AuthFrame";
import { Btn, Field, Overline } from "@/components/kit";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Please enter your email and password.");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (err) {
      toast.error(apiError(err, "Unable to sign in."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFrame>
      <Overline className="text-center mb-4">ME₀ → ME₁₁ · The Emergence Journal</Overline>
      <h1 className="font-serif text-4xl text-ink text-center">Welcome back</h1>
      <p className="text-inkfaint text-center mt-2 mb-8">Return to the person who is here now.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email" type="email" placeholder="you@example.com" value={email}
          onChange={(e) => setEmail(e.target.value)} data-testid="login-email" autoComplete="email" />
        <Field label="Password" type="password" placeholder="Your password" value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="login-password" autoComplete="current-password" />
        <Btn type="submit" className="w-full" disabled={loading} data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </Btn>
      </form>
      <div className="text-center mt-5">
        <Link to="/forgot-password" className="text-sm text-gold hover:underline" data-testid="forgot-link">
          Forgot your password?
        </Link>
      </div>
      <p className="text-center text-sm text-inkfaint mt-8">
        New here?{" "}
        <Link to="/register" className="text-gold hover:underline" data-testid="to-register">Create an account</Link>
      </p>
    </AuthFrame>
  );
}
